import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import StarIcon from '@offerzen/zenicon/StarIcon'
import StarOutlineIcon from '@offerzen/zenicon/StarOutlineIcon'
import AccessibleIcon from '../../../elements/AccessibleIcon'
import { colors } from '../../../themes'

import styles from './styles'

const FavouriteButton = ({ label, hasFavourite, className, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <button className={cx(styles.button, className)} {...props} type="button">
    <AccessibleIcon icon={hasFavourite ? StarIcon : StarOutlineIcon} size={12} color={colors.amethyst} className={styles.icon} />
    {label}
  </button>
)

FavouriteButton.propTypes = {
  label: PropTypes.string.isRequired,
  hasFavourite: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

FavouriteButton.defaultProps = {
  type: 'button',
  hasFavourite: false,
}

export default FavouriteButton
